/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design System — DataTable toolbar.
 *
 * Purely a layout shell: it positions whatever the caller passes into `left` and
 * `right` so every table's toolbar lines up, without dictating which controls
 * appear. Exported on its own for tables that need the bar outside the frame.
 */
import cx from 'classnames';

import type { DataTableToolbarProps } from '../../types';

const DataTableToolbar = ({ left, right, className }: DataTableToolbarProps) => (
  <div className={cx('ds-data-table__toolbar', className)}>
    <div className="ds-data-table__toolbar-slot">{left}</div>
    <div className="ds-data-table__toolbar-slot ds-data-table__toolbar-slot--right">{right}</div>
  </div>
);

DataTableToolbar.displayName = 'DataTableToolbar';

export default DataTableToolbar;
